import makeStyles from '@material-ui/core/styles/makeStyles';
import { parseLogin } from '../../../../../../@casino/lib/parseLogin';

const useStyles = makeStyles(() => ({
    root: {
        padding: 20, 
        height: 'calc(100% - 40px)',
        overflowY: 'scroll', 
        paddingTop: 0
    },
    rootTable: {
        width: 'calc(100% - 30px)', borderCollapse: 'inherit', borderSpacing: 0,
        '.trTable': {
            
        }
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    },
    wrap: {
        padding: 0, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    wrapBlock: {
        padding: 20, 
        background: '#1b2039', 
        borderRadius: 8, 
        marginBottom: 12
    },
    search: {
        padding: 10,
        background: '#141b33',
        paddingLeft: 10,
        border: '1px solid #141b33',
        color: '#fff',
        outline: 'none',
        margin: 10,
        width: 300
    },
    wrapSwitch: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165,
    },
    manually: {
        display: 'flex', 
        alignItems: 'center', 
        width: 165, 
        color: '#fff'
    },
    spo: {
        width: 40, 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        background: '#141b33',
        color: '#fff',
        boxShadow: '4px 4px 8px 0px rgb(34 60 80 / 20%)',
    },
    datetime: {
        border: 'none', 
        outline: 'none', 
        paddingLeft: 15, 
        borderRadius: 4, 
        background: '#34488c',
        color: '#fff'
    },
}));



const columns = [
    { id: 'login_user', label: 'Логин'},
    { id: 'count', label: 'Количество'},
    { id: 'replenishment', label: 'Пополнения'},
    { id: 'withdrawal', label: 'Вывод'},
    { id: 'result', label: 'Разница'},
    { id: 'replenishment_air', label: 'Пополнения(воздух)'},
    { id: 'withdrawal_air', label: 'Вывод(воздух)'},
    { id: 'result_air', label: 'Разница(воздух)'}
];

const getRows = (replenishment) => {
    return replenishment.data.map((item, key) => {
        return {
            id: key + 1,
            login_user: item.login_user ? parseLogin(item.login_user) : '-',
            count: new Intl.NumberFormat('ru-RU').format(item.count),
            replenishment: new Intl.NumberFormat('ru-RU').format(item.sum_replenishment) + '₽',
            withdrawal:  new Intl.NumberFormat('ru-RU').format(item.sum_withdrawal) + '₽',
            result: new Intl.NumberFormat('ru-RU').format(item.sum_replenishment - item.sum_withdrawal) + '₽',
            replenishment_air:  new Intl.NumberFormat('ru-RU').format(item.sum_replenishment_air) + '₽', 
            withdrawal_air:  new Intl.NumberFormat('ru-RU').format(item.sum_withdrawal_air) + '₽', 
            result_air: new Intl.NumberFormat('ru-RU').format(item.sum_replenishment_air - item.sum_withdrawal_air) + '₽',
        }
    })
}

export {
    useStyles,
    columns,
    getRows
}